import { AddOns } from '../../../constants/add-ons';
import { ReturnRabbit } from '../../../constants/upsell-modal-content-codes';

export const ActivateAddOnModalQueryParam = 'addonActivateModalOpen';
export const AddOnCodeQueryParam = 'addonCode';
export const DeactivateAddOnModalQueryParam = 'addonDeactivateModalOpen';

export const ADD_ONS_WITH_SETTINGS = [
  AddOns.ODBC,
  AddOns.Cubiscan,
  AddOns.ShippingStrategies,
  AddOns.AutoSplit,
  AddOns.InventorySync,
  ReturnRabbit,
  AddOns.InventoryApi,
  AddOns.ShipStationApiV2,
];

export const MESH_ADD_ONS = [AddOns.DropShip, AddOns.FulfillmentProviderBundle];

/** BEGIN: SEGMENT TRACKING */
export const ADD_WORKFLOW_TYPE_ACTIVATION = 'Activation';
export const ADD_WORKFLOW_TYPE_DEACTIVATION = 'Deactivation';

// One off events - NOT workflows
export const ADD_ON_CONFIGURE_SETTINGS_CLICKED = 'ADD_ON_CONFIGURE_SETTINGS_CLICKED';
export const ADD_ON_KNOWLEDGE_BASE_CLICKED = 'ADD_ON_KNOWLEDGE_BASE_CLICKED';

// Sources
export const BUTTON = 'BUTTON';
export const ACTION_MENU = 'ACTION-MENU';
/** END: SEGMENT TRACKING */
